import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { MetricQuery } from "~/models/metric-query";

import type { MonitorCheckStatusMetric } from "../../../../../../common/openapi";
import { ChartWidget } from "../../../../../../components/widget-form/widget";

import { useMonitorStatusContext } from "./_monitor-status-context";

export interface MonitorStatusMetricsProps {
	metrics: ReadonlyArray<MonitorCheckStatusMetric>;
}

export const MonitorStatusMetrics: React.FC<MonitorStatusMetricsProps> = ({ metrics }) => {
	const { timeRange } = useMonitorStatusContext();
	const timeRangeValue = useComputed(timeRange);

	return (
		<div className="space-y-4" data-testid="monitor-status-metrics">
			{metrics.map(({ name, description, unit, queries }) => (
				<ChartWidget
					batch={name}
					chart={{
						kind: "TimeSeriesChart",
						settings: { unit },
					}}
					description={description}
					key={name}
					onTimeRangeChange={(nextTimeRange) => timeRange.write(nextTimeRange)}
					queries={queries.map(MetricQuery)}
					timeRange={timeRangeValue}
					timestamp={undefined}
					title={name}
				/>
			))}
		</div>
	);
};
